function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Form } from 'react-bootstrap';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
export function EmployeeActivityTotalsRow(_ref) {
  let {
    claim
  } = _ref;
  const claimEmployeeTotalSalary = Number(claim.employee_wage_totals).toString();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 3 + (claim.claim_group.project_methodology === 'project_basis' ? 2 * claim.claim_group.claim_project_reports.length : 0)
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      minWidth: '70pt',
      maxWidth: '70pt'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    object: claim,
    disabled: true,
    name: "employees_weighted_rnd",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: _objectSpread(_objectSpread({}, claim), {}, {
      claim_employee_total_salary: claimEmployeeTotalSalary
    }),
    disabled: true,
    name: "employee_wage_totals",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", {
    style: {
      minWidth: '120pt',
      maxWidth: '120pt'
    }
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    object: claim,
    disabled: true,
    name: "employee_qualifying_rnd_expenditure",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null)));
}